import { render } from "./optionbutton.vue?vue&type=template&id=40523d44"
import script from "./optionbutton.vue?vue&type=script&lang=js"
export * from "./optionbutton.vue?vue&type=script&lang=js"

import "./optionbutton.vue?vue&type=style&index=0&id=40523d44&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__